import { useState } from "react";
import UrlImporter from "./UrlImporter"; // Assure-toi que le chemin est correct
import ObjectEditor from "./ObjectEditor";
import { EditableObject } from "../bean/EditableObject";

function UrlImporterTest() {
  const [isOpen, setIsOpen] = useState(false);
  const [editable, setEditable] = useState(null);
  const [showEditor, setShowEditor] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const handleResult = (result) => {
    setLastResult(result);
    setIsOpen(false); // referme proprement
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Test de UrlImporter</h2>
      <button onClick={() => setIsOpen(true)}>Ouvrir l’importeur</button>

      {isOpen && (
        <UrlImporter
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onResult={(result) => {
            if (result) {
              const editableObj = EditableObject.fromImportedObject(result);
              setEditable(editableObj);
              handleResult(editableObj);
            }
            setIsOpen(false);
            setShowEditor(true);
          }}
          onManualEdit={() => {
            setShowEditor(true);
          }}
        />
      )}
      {!isOpen && (
        <button className="kdo-object kdo-add-tile" onClick={() => setIsOpen(true)} aria-label="Ajouter un article">
          <span className="kdo-add-icon">+</span>
        </button>
      )}

       {editable && (
        <div style={{ marginTop: "20px" }}>
          showEditor : {showEditor.toString()}
          <h3>{editable.title}</h3>
          <img src={editable.image} alt="Aperçu" style={{ width: "150px", borderRadius: "10px" }} />
          <p>{editable.description}</p>
          <button onClick={() => setShowEditor(true)}>Modifier les infos</button>
        </div>
      )}

      {showEditor && (
        <ObjectEditor
          object={editable}
          onCancel={() => setShowEditor(false)}
          onSave={(updatedObject) => {
            console.log("Objet mis à jour :", updatedObject);
            setEditable(updatedObject);
              handleResult(updatedObject);
            setShowEditor(false);
          }}
        />
      )}

      {lastResult !== null && (
        <div style={{ marginTop: "20px" }}>
          <h3>Résultat :</h3>
          <pre>{JSON.stringify(lastResult, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}

export default UrlImporterTest;
